import { render } from "./sms-code.vue?vue&type=template&id=6a7ce582"
import script from "./sms-code.vue?vue&type=script&lang=js"
export * from "./sms-code.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__